import { useLazyQuery } from '@apollo/client';
import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { INode } from 'ts/interfaces';

interface INodeQuery {
    variables: {
        id: number;
    };
}

interface ILazyNodeQuery {
    variables: {
        id: number;
        cb: (data: INode) => void;
    };
}

export const GET_NODE = gql`
    query GetNode($id: ID!) {
        node(id: $id) {
            id
            node_attributes
            parent_id
            children {
                id
                node_attributes
                parent_id
                children {
                    id
                    node_attributes
                    parent_id
                    children {
                        id
                        node_attributes
                        parent_id
                    }
                }
            }
        }
    }
`;

export const GET_NODES = gql`
    query GetNodes {
        nodes {
            id
            node_attributes
            parent_id
            code
            children {
                id
                node_attributes
                parent_id
                code
                children {
                    id
                    node_attributes
                    parent_id
                    code
                }
            }
        }
    }
`;

export const GET_ROOTNODES = gql`
    query GetRootNodes {
        nodes(parent_id: null) {
            id
            node_attributes
            parent_id
            code
            is_edited
            children {
                id
                node_attributes
                parent_id
                code
                children {
                    id
                    node_attributes
                    parent_id
                    code
                }
            }
        }
    }
`;

const useGetNode = ({ variables }: INodeQuery) => {
    return useQuery(GET_NODE, {
        notifyOnNetworkStatusChange: false,
        fetchPolicy: 'network-only',
        variables,
    });
};

const useLazyGetNode = ({ variables }: ILazyNodeQuery) => {
    return useLazyQuery(GET_NODE, {
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: false,
        onCompleted: (data: INode) => variables?.cb(data),
        variables,
    });
};

const useGetNodes = () => {
    return useQuery(GET_NODES, {
        notifyOnNetworkStatusChange: false,
        fetchPolicy: 'network-only',
    });
};

const useGetRootNodes = () => {
    return useQuery(GET_ROOTNODES, {
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'network-only',
        returnPartialData: false,
        partialRefetch: true,
    });
};

export { useGetNode, useGetNodes, useGetRootNodes, useLazyGetNode };
